export const siteData = {
  pressRelease_2022_1_18_url: "https://www.prlog.org/12903775"
}